// extracted by mini-css-extract-plugin
module.exports = {"tagline":"TagLine_tagline__27vN7","taglineTitle":"TagLine_tagline-title__1YJrc","description":"TagLine_description__3do0m"};